import { Reducer } from 'redux';
import { ServiceDiscoveryState, ServiceDiscoveryTypes } from './types';

const INITIAL_STATE: ServiceDiscoveryState = {
  serviceDiscoveryList: [],
  serviceDiscoveryData: {
    type: '',
    title: '',
    subtitle: '',
    key: '',
    value: '',
  },
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<ServiceDiscoveryState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    // LIST SERVICE DISCOVERY
    case ServiceDiscoveryTypes.LIST_SERVICE_DISCOVERY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        serviceDiscoveryList: INITIAL_STATE.serviceDiscoveryList,
      };
    case ServiceDiscoveryTypes.LIST_SERVICE_DISCOVERY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        serviceDiscoveryList: action.payload.serviceDiscoveryList,
        totalCount: action.payload.totalCount,
      };
    case ServiceDiscoveryTypes.LIST_SERVICE_DISCOVERY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        serviceDiscoveryList: INITIAL_STATE.serviceDiscoveryList,
      };

    // UPDATE SERVICE DISCOVERY
    case ServiceDiscoveryTypes.UPDATE_SERVICE_DISCOVERY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        serviceDiscoveryData: action.payload.serviceDiscoveryData,
      };
    case ServiceDiscoveryTypes.UPDATE_SERVICE_DISCOVERY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        serviceDiscoveryData: action.payload.serviceDiscoveryData,
      };
    case ServiceDiscoveryTypes.UPDATE_SERVICE_DISCOVERY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        serviceDiscoveryData: action.payload.serviceDiscoveryData,
      };

    default:
      return state;
  }
};

export default reducer;
